const STANDARD_CONTACT_FIELDS = new Set([
  'name',
  'email',
  'phone_number',
  'identifier',
]);

export const normalizeEventFieldKey = question => {
  const fieldKey = question?.target_field || question?.field_key || '';

  if (
    !fieldKey ||
    fieldKey.includes('.') ||
    STANDARD_CONTACT_FIELDS.has(fieldKey)
  ) {
    return fieldKey;
  }

  return `custom_attributes.${fieldKey}`;
};
